<template>
  <Transition>
    <div v-if="state === 'username'" class="login__init default-page-anim">
      <Transition appear>
        <Page class="default-page-anim">
          <SAM
            :data="language.Login.username_prompt"
            class="page-content-anim page-content-margin"
            gradient
          />
          <TextInput
            class="page-content-margin"
            :inputLabel="language.Login.username_label"
            :submitLabel="language.Login.submit_label"
            autocomplete="username"
            type="email"
            @submit="hideWarning"
            @next="usernameSubmit"
            ref="input"
            async
          />
          <InputWarning ref="warning" />
          <Dialogue
            v-if="guestId"
            :options="[language.Login.guest_prompt]"
            @choice="startGuestMode"
          />
        </Page>
      </Transition>
      <button
        type="button"
        class="login__language page-content-anim"
        :class="{
          'login__language--chosen': languageSelected,
        }"
        @click="toLanguage"
      >
        <span class="login__language__text">
          <span
            class="login__language__text-inner"
            :class="{
              'login__language__text-inner--chosen': languageSelected,
            }"
            >{{ language.name }}</span
          >
        </span>
        <svg
          class="login__language__icon"
          viewBox="0 0 14 14"
          aria-hidden="true"
        >
          <path
            d="M7 14C5.61553 14 4.26215 13.5895 3.11101 12.8203C1.95987 12.0511 1.06266 10.9579 0.532846 9.67878C0.003033 8.3997 -0.13559 6.99224 0.134506 5.63437C0.404603 4.2765 1.07129 3.02922 2.05026 2.05025C3.02922 1.07129 4.2765 0.404603 5.63437 0.134506C6.99224 -0.13559 8.3997 0.00303364 9.67879 0.532846C10.9579 1.06266 12.0511 1.95987 12.8203 3.11101C13.5895 4.26215 14 5.61553 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14ZM7.38889 9.36664C8.20345 9.37977 9.01621 9.44768 9.82166 9.56991C9.98948 8.8495 10.0843 8.11403 10.1048 7.37461H7.38889V9.36664ZM7.38889 10.1511V13.1659C7.99377 12.9951 8.59014 12.4357 9.06996 11.572C9.28807 11.1745 9.46853 10.7575 9.60898 10.3264C8.87331 10.2219 8.13184 10.1634 7.38889 10.1511ZM6.61111 13.1659V10.1511C5.86816 10.1634 5.12669 10.2219 4.39102 10.3264C4.53147 10.7575 4.71193 11.1745 4.93004 11.572C5.40986 12.4357 6.00625 12.9951 6.61111 13.1659ZM6.61111 9.36664V7.37461H3.89521C3.91566 8.11403 4.01052 8.8495 4.17835 9.56991C4.98379 9.44768 5.79655 9.37977 6.61111 9.36664ZM3.11678 7.37461H0.79007C0.850921 8.40285 1.16784 9.39956 1.71202 10.2741C2.25468 10.019 2.82608 9.83025 3.41388 9.71182C3.23732 8.94458 3.13779 8.16163 3.11678 7.37461ZM3.11799 6.59683C3.14043 5.81942 3.23955 5.04612 3.4139 4.28819C2.82609 4.16975 2.25469 3.98096 1.71203 3.72588C1.17311 4.59225 0.857117 5.57859 0.79226 6.59683H3.11799ZM3.89635 6.59683H6.61111V4.63336C5.79655 4.62023 4.98379 4.55232 4.17835 4.43009C4.01271 5.1412 3.91825 5.86702 3.89635 6.59683ZM6.61111 3.8489V0.834092C6.00625 1.00494 5.40986 1.5643 4.93004 2.42798C4.71193 2.82546 4.53148 3.24247 4.39102 3.67356C5.12669 3.77806 5.86816 3.83662 6.61111 3.8489ZM7.38889 0.834092V3.8489C8.13184 3.83662 8.87331 3.77806 9.60898 3.67356C9.46853 3.24247 9.28807 2.82546 9.06996 2.42798C8.59014 1.5643 7.99377 1.00494 7.38889 0.834092ZM7.38889 4.63336V6.59683H10.1036C10.0817 5.86702 9.98729 5.1412 9.82165 4.43009C9.01621 4.55232 8.20345 4.62023 7.38889 4.63336ZM10.882 6.59683H13.2077C13.1429 5.57859 12.8269 4.59225 12.288 3.72588C11.7453 3.98096 11.1739 4.16975 10.5861 4.28819C10.7605 5.04612 10.8596 5.81942 10.882 6.59683ZM10.8832 7.37461C10.8622 8.16163 10.7627 8.94458 10.5861 9.71182C11.1739 9.83025 11.7453 10.019 12.288 10.2741C12.8321 9.39956 13.1491 8.40285 13.2099 7.37461H10.8832ZM11.8311 10.9156C11.3651 10.7121 10.8783 10.5602 10.3792 10.4627C10.124 11.3283 9.70373 12.1364 9.14153 12.8423C10.1949 12.4534 11.124 11.7879 11.8311 10.9156ZM4.85847 12.8423C4.29628 12.1364 3.87598 11.3283 3.62077 10.4627C3.12174 10.5602 2.6349 10.7121 2.16893 10.9156C2.87603 11.7878 3.80511 12.4534 4.85847 12.8423ZM2.16892 3.08441C2.63489 3.2879 3.12174 3.43976 3.62076 3.53729C3.87599 2.67168 4.29628 1.86362 4.85847 1.15767C3.80511 1.54658 2.87602 2.21216 2.16892 3.08441ZM9.14153 1.15767C9.70372 1.86362 10.124 2.67168 10.3792 3.53729C10.8783 3.43976 11.3651 3.2879 11.8311 3.08441C11.124 2.21215 10.1949 1.54657 9.14153 1.15767Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>
    <Page v-else-if="state === 'password'" class="default-page-anim">
      <SAM
        :data="
          hasTempPassword
            ? language.Login.password_temp_prompt
            : language.Login.password_prompt
        "
        class="page-content-anim page-content-margin"
        gradient
      />
      <TextInput
        class="page-content-margin"
        :inputLabel="language.Login.password_label"
        :submitLabel="language.Login.submit_label"
        :autocomplete="hasTempPassword ? 'off' : 'current-password'"
        type="password"
        @submit="hideWarning"
        @next="passwordSubmit"
        ref="input"
        async
        :hiddenName="language.Login.username_label"
        :hiddenValue="username"
        hiddenType="username"
      />
      <InputWarning ref="warning" />
      <Dialogue
        v-if="!hasTempPassword"
        :options="[language.Login.password_reset_prompt || 'Forgot password?']"
        @choice="forgotPasswordCheck"
      />
    </Page>
    <Page v-else-if="state === 'new-password'" class="default-page-anim">
      <SAM
        :data="language.Login.new_password_prompt"
        class="page-content-anim page-content-margin"
        gradient
      />
      <TextInput
        class="page-content-margin"
        :inputLabel="language.Login.new_password_label"
        :submitLabel="language.Login.submit_label"
        autocomplete="new-password"
        minlength="6"
        type="password"
        @submit="hideWarning"
        @next="setNewPassword"
        ref="input"
        async
        :hiddenName="language.Login.username_label"
        :hiddenValue="username"
        hiddenType="username"
      />
      <InputWarning ref="warning" />
    </Page>
    <Page v-else-if="state === 'reset-password'" class="default-page-anim">
      <SAM
        :data="language.Login.verification_prompt"
        class="page-content-anim page-content-margin"
        gradient
      />
      <TextInput
        class="page-content-margin"
        :inputLabel="language.Login.verification_code_label"
        :submitLabel="language.Login.submit_label"
        autocomplete="off"
        inputmode="numeric"
        @submit="hideWarning"
        @next="verificationSubmit"
        ref="input"
        async
      />
      <InputWarning ref="warning" />
    </Page>
    <Page v-else-if="state === 'forgot-password'" class="default-page-anim">
      <SAM
        :data="language.Login.password_reset_prompt"
        class="page-content-anim page-content-margin"
        gradient
      />
      <InputWarning ref="warning" />
      <Dialogue
        gradient
        :options="[
          language.Login.password_reset_confirm,
          language.Login.password_reset_dismiss,
        ]"
        @choice="forgotPassword"
      />
    </Page>
  </Transition>
</template>

<script>
import Page from "@/components/pages/Page.vue";
import SAM from "@/components/content/SAM.vue";
import TextInput from "@/components/content/TextInput.vue";
import Dialogue from "@/components/content/Dialogue.vue";
import InputWarning from "@/components/content/InputWarning.vue";

import * as AudioManager from "@/scripts/audioManager.js";
import SessionData from "@/scripts/sessionData.js";
import * as Analytics from "@/scripts/analytics.js";

import { data } from "@/scripts/data.js";
import { Auth } from "@aws-amplify/auth";
import { API } from "@aws-amplify/api";

const API_NAME = "PublicAPI";
const API_PATH = "/app/check";

export default {
  emits: ["next", "toLanguage", "startGuestMode"],
  components: {
    Page,
    SAM,
    TextInput,
    InputWarning,
    Dialogue,
  },
  props: {
    guestId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      data,
      state: "username",
      // 0 - 'username' - Initial state, username prompt
      // 1 - 'password' - Username found, password prompt
      // 2 - 'new-password' - New password needed, either first login or a password reset, new password prompt
      // 3 - 'reset-password' - Password reset 2FA, verification prompt
      // 4 - 'forgot-password' - Confirm password reset
      // Normal login: 'username' -> 'password'
      // First time login: 'username' -> 'password' -> 'new-password'
      // In app password reset: 'username' -> 'password' -> 'forgot-password' -> 'reset-password' -> 'new-password'
      // Login with pending password reset: 'iusername' -> 'reset-password' -> 'new-password'
      username: "",
      user: "",
      verificationCode: "",
      language: SessionData.lang,
      languageSelected: false,
      hasTempPassword: false,
      destroyed: false,
    };
  },
  methods: {
    toUsername() {
      this.state = "username";
    },
    toPassword() {
      this.state = "password";
    },
    toNewPass() {
      this.state = "new-password";
    },
    toReset() {
      this.state = "reset-password";
    },

    usernameSubmit(username) {
      if (this.languageSelected) return;

      const payload = {
        queryStringParameters: {
          username: username,
        },
      };
      API.get(API_NAME, API_PATH, payload)
        .then((res) => {
          if (this.destroyed !== false) return;
          if (res === "USER_NOT_FOUND") {
            this.$refs.warning.show(this.language.Login.username_invalid_error);
            this.$refs.input.error();
          } else if (res === "USER_EXISTS") {
            // save username for use in app, and continue to the password screen
            this.username = username;
            this.$refs.input.success();
            this.timeout = setTimeout(this.toPassword, 300);
          } else if (res === "FORCE_CHANGE_PASSWORD") {
            this.hasTempPassword = true;
            this.username = username;
            this.$refs.input.success();
            this.timeout = setTimeout(this.toPassword, 300);
          }
        })
        .catch((error) => {
          console.error(error);
          if (this.destroyed !== false) return;
          let errorWarning = "";
          if (error.code === "ERR_NETWORK") {
            errorWarning = this.language.Login.network_error;
          } else {
            errorWarning = this.language.Login.misc_error;
          }
          this.$refs.warning.show(errorWarning);
          this.$refs.input.error();
        });
      return;
    },
    passwordSubmit(password) {
      Auth.signIn(this.username, password)
        .then((user) => {
          if (this.destroyed !== false) return;
          this.user = user;
          if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
            this.$refs.input.success();
            this.timeout = setTimeout(this.toNewPass, 300);
          } else {
            Analytics.trackSession(user);
            this.$refs.input.success();
            this.timeout = setTimeout(this.fin, 300);
          }
        })
        .catch((error) => {
          console.error(error);
          if (this.destroyed !== false) return;
          // reset
          if (error.message === "Password reset required for the user") {
            this.$refs.input.success();
            this.timeout = setTimeout(this.toReset, 300);
            return;
          }
          // actual errors
          let errorWarning = "";
          switch (error.message) {
            case "Incorrect username or password.":
              errorWarning = this.language.Login.password_invalid_error;
              break;
            case "Temporary password has expired and must be reset by an administrator.":
              errorWarning = this.language.Login.password_expired_error;
              break;
            case "Password attempts exceeded":
              errorWarning = this.language.Login.password_attempts_error;
              break;
            default:
              errorWarning = this.getGenericAuthError(error);
              break;
          }
          this.$refs.warning.show(errorWarning);
          this.$refs.input.error();
        });
    },
    setNewPassword(password) {
      if (this.verificationCode) {
        Auth.forgotPasswordSubmit(
          this.username,
          this.verificationCode,
          password
        )
          .then(() => {
            if (this.destroyed !== false) return;
            Auth.signIn(this.username, password).then(this.afterSetNewPassword);
          })
          .catch(this.failedSetNewPassword);
      } else {
        Auth.completeNewPassword(this.user, password)
          .then(this.afterSetNewPassword)
          .catch(this.failedSetNewPassword);
      }
    },
    hideWarning() {
      this.$refs.warning.hide();
    },
    afterSetNewPassword() {
      if (this.destroyed !== false) return;
      Auth.currentAuthenticatedUser().then((user) => {
        if (this.destroyed !== false) return;
        this.user = user;
        Analytics.trackSession(user);
        this.$refs.input.success();
        this.timeout = setTimeout(this.fin, 300);
        Analytics.trackEvent("reset_password");
      });
    },
    failedSetNewPassword(error) {
      if (this.destroyed !== false) return;
      let errorWarning = "";
      if (error.code === "InvalidPasswordException") {
        errorWarning = this.language.Login.new_password_invalid_error;
      } else {
        errorWarning = this.getGenericAuthError(error);
        if (this.verificationCode) {
          // allow user to re enter code
          this.timeout = setTimeout(this.toReset, 2500);
        } else {
          // reset
          this.timeout = setTimeout(this.toUsername, 2500);
        }
      }
      this.$refs.warning.show(errorWarning);
      this.$refs.input.error();
    },
    getGenericAuthError(error) {
      let errorWarning = "";
      switch (error.message) {
        case "Network error":
          errorWarning = this.language.Login.network_error;
          break;
        default:
          errorWarning = this.language.Login.misc_error;
          break;
      }
      return errorWarning;
    },
    forgotPasswordCheck() {
      this.state = "forgot-password";
    },
    forgotPassword(choice) {
      if (choice === 0) {
        Auth.forgotPassword(this.username)
          .then(() => {
            if (this.destroyed !== false) return;
            this.toReset();
          })
          .catch((error) => {
            console.error(error);
            if (this.destroyed !== false) return;
            const errorWarning = this.getGenericAuthError(error);
            this.$refs.warning.show(errorWarning);
            this.timeout = setTimeout(this.toUsername, 2500);
          });
      } else {
        this.toUsername();
      }
    },

    verificationSubmit(code) {
      // The code needs to be explicitly converted to a string for the reset
      this.verificationCode = code.toString();
      this.toNewPass();
    },
    afterLanguage() {
      this.$emit("toLanguage");
    },
    toLanguage() {
      if (this.languageSelected) return;
      AudioManager.play("ui-input-button-misc");
      this.languageSelected = true;
      this.langTimeout = setTimeout(this.afterLanguage, 750);
    },
    fin() {
      this.$emit("next", this.user);
    },
    startGuestMode() {
      this.$emit("startGuestMode", this.guestId);
    },
  },
  mounted() {
    this.$root.setHeaderDisplay(false);
  },
  beforeUnmount() {
    clearTimeout(this.langTimeout);
    clearTimeout(this.timeout);
    this.destroyed = true;
  },
};
</script>
<style lang="scss">
.login {
  &__init {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  &__language {
    @include reset-button;

    display: flex;
    align-items: center;

    position: absolute;
    z-index: 2;
    top: $page-top;
    right: var(--container-indent);
    margin: -0.25rem -0.5rem 0 0;

    padding: 0.5rem 1rem;
    border-radius: 1rem;
    background-color: #000;

    color: #fff;
    font-family: $comfortaa;
    font-size: 1rem;
    font-weight: 700;

    transform-origin: right top;
    transform: translate3d(0, 0, 0);

    pointer-events: auto;

    @keyframes login-language-button-out {
      50% {
        color: #000;
        background-color: #fff;
      }
      to {
        transform: translate3d(0, 0, 0) scale(1.1);
        color: #000;
        background-color: #fff;
      }
    }

    &--chosen {
      pointer-events: none;
      animation: login-language-button-out 0.75s ease 1 both;
    }

    &__icon {
      width: 1em;
      height: auto;
      margin-left: 0.5em;
    }

    &__text {
      display: block;
      overflow: hidden;
      overflow: clip;
      height: fit-content;
    }

    &__text-inner {
      display: block;
      animation: login-language-button-in 0.5s ease 1.5s 1 both;

      @keyframes login-language-button-in {
        from {
          opacity: 0;
          transform: translateX(100%);
        }
      }
    }
  }
}
</style>
